import React from 'react'

import Maincomp from '../Components/home/Maincomp'

function HomePage() {
  return (
   <Maincomp/>
  )
}

export default HomePage